import * as R from 'ramda';

// replaces all instances of multiple spaces with a single space
const replaceMultipleWhitespace = R.o(R.trim, R.replace(/\s\s+/g, ' '));

const getIndexOfSelector = (viewById, selectorsList, prop = 'nameShort') => {
  const adjustedViewById = R.o(replaceMultipleWhitespace, decodeURI)(viewById);

  // compareFun :: object -> bool
  const compareFun = R.compose(R.equals(adjustedViewById), replaceMultipleWhitespace, R.prop(prop));

  return R.findIndex(compareFun, selectorsList);
};

export default getIndexOfSelector;
